import { SectionSummary } from './SectionSummary.types';

export const formatChipLabel = (summary: Pick<SectionSummary, 'shortName' | 'count'>): string =>
   `${summary.shortName} (${summary.count})`;
